import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import './preview.scss'
import styled from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import template from 'components/../../public/sashidashihyo.jpg'
import { NaviSample, NaviSampleSearchForm } from 'entities/navi_sample'
import { useFetchNaviSamplesApi } from 'api/navi_sample'
import { NaviSampleViewModal } from 'view_models/navi_sample_view_model'

type Props = {
    history: H.History
}

const Th = styled.th`
    border-right: solid 1px black;
    background-color: #e1e1e1;
    padding: 5px 10px;
    text-align: center;
    font-size: 14px;
    vertical-align: center;
`

const Td = styled.td`
    border-right: solid 1px black;
    padding: 5px;
`

const NaviPostageSlipsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<NaviSampleSearchForm>()
    const [post, setPost] = useState<number>(0)

    const searchForm = useForm<NaviSampleSearchForm>({
        ...params,
        perPage: 1000,
    })
    const naviSamplesApi = useFetchNaviSamplesApi(searchForm)

    useEffect(() => {
        naviSamplesApi.execute()
    }, [])

    useEffect(() => {
        if (naviSamplesApi.response.results.length === 0) return
        setPost(naviSamplesApi.response.results.length)
    }, [naviSamplesApi.response.results])

    useEffectSkipFirst(() => {
        globalState.setLoading(naviSamplesApi.loading)
    }, [naviSamplesApi.loading])

    const checklistChunk = (): NaviSample[][] => {
        if (naviSamplesApi.response.results) {
            return _.chunk(naviSamplesApi.response.results, 15)
        }
        return []
    }

    return (
        <div className="preview-request-form">
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="center">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            <A4 padding={0} landscape={false}>
                <div className="page-root" style={{ width: '100.5%', height: '100%', position: 'relative' }}>
                    <img src={template} style={{ objectFit: 'contain', width: '100%' }} />
                    {/*  通数  */}
                    <div style={{ position: 'absolute', left: 403, top: 936, fontSize: 17, width: 69, textAlign: 'center' }}>{post.toLocaleString()}</div>
                    <div style={{ position: 'absolute', left: 403, top: 1038, fontSize: 17, width: 69, textAlign: 'center' }}>{post.toLocaleString()}</div>

                    {/*  通数×金額  */}
                    <div style={{ position: 'absolute', left: 560, top: 936, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {(post * 530).toLocaleString()}
                    </div>
                    <div style={{ position: 'absolute', left: 560, top: 1038, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {(post * 530).toLocaleString()}
                    </div>
                </div>
            </A4>
            <PreviewRequestNaviPostList SplitNaviSamplesList={checklistChunk()} type="submission" />
            <PreviewRequestNaviPostList SplitNaviSamplesList={checklistChunk()} type="storage" />

            {checklistChunk().map((samples, index) => {
                return (
                    <A4 padding={10} landscape={false} key={'checklist-' + index}>
                        <div className={'preview-request-list'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                            <div style={{ width: '100%', marginBottom: 30, marginTop: 30 }}>
                                <div style={{ width: '100%', textAlign: 'right', marginBottom: 30 }}>{moment().format('YYYY/MM/DD')}</div>
                                <div style={{ fontSize: 25, fontWeight: 'bold', width: '100%', textAlign: 'center' }}>郵便書類チェックリスト</div>
                            </div>

                            <table style={{ width: '100%', border: 'solid 1px black', borderRightWidth: 0, borderBottomWidth: 0, fontSize: 12 }}>
                                <thead>
                                    <tr style={{ borderBottom: 'solid 1px black' }}>
                                        <Th style={{ fontSize: 12, width: 30 }}>#</Th>
                                        <Th style={{ fontSize: 12, width: 100 }}>検体コード</Th>
                                        <Th style={{ fontSize: 12, width: 150 }}> お届け先のお名前</Th>
                                        <Th style={{ fontSize: 12, width: 140 }}>結果表</Th>

                                        <Th style={{ fontSize: 12, width: 90 }}>パンフレット</Th>

                                        <Th style={{ fontSize: 12, width: 85 }}>
                                            ストーリー
                                            <br />
                                            冊子
                                        </Th>
                                        <Th style={{ fontSize: 12, width: 90 }}>クーポン</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {new Array(9).fill(0).map((_, sampleIndex) => {
                                        const sample: NaviSample | undefined = samples[sampleIndex]
                                        const vm = new NaviSampleViewModal(sample)

                                        return (
                                            <tr key={sample?.id} style={{ borderBottom: 'solid 1px black' }}>
                                                <Td style={{ verticalAlign: 'inherit' }}>
                                                    <div style={{ minHeight: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div>{sampleIndex + 1}</div>
                                                    </div>
                                                </Td>
                                                <Td>{sample?.code}</Td>
                                                <Td style={{ fontSize: 10, padding: '0 5px' }}>
                                                    {sample
                                                        ? `${sample?.patient?.familyName || ''} ${sample?.patient?.givenName || ''}(${
                                                              sample?.patient?.familyNameKana || ''
                                                          } ${sample?.patient?.givenNameKana || ''})`
                                                        : ''}
                                                </Td>
                                                <Td>
                                                    <Flex style={{ fontSize: 10 }} flexWrap="wrap">
                                                        {sample &&
                                                            vm.convertNaviCancerName().map((cancerName, index) => {
                                                                return (
                                                                    <Flex key={'prod' + index} justifyContent="center" alignItems="center" className="">
                                                                        <div style={{ marginRight: 5 }}>{cancerName}</div>
                                                                        <div style={{ width: 10, height: 10, border: 'solid 1px black' }}></div>
                                                                    </Flex>
                                                                )
                                                            })}
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Flex justifyContent="center">
                                                        <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Flex justifyContent="center">
                                                        <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Flex justifyContent="center">
                                                        <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                    </Flex>
                                                </Td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Flex justifyContent="flex-end" style={{ marginTop: 30 }}>
                                <div>
                                    <table style={{ fontSize: 14, border: 'solid 1px black' }}>
                                        <thead style={{ backgroundColor: '#e1e1e1', borderBottom: 'solid 1px black', textAlign: 'center' }}>
                                            <tr>
                                                <th style={{ width: 100, borderRight: 'solid 1px black' }}>封入者</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderRight: 'solid 1px black' }}>
                                                    <div style={{ height: 60 }}></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Flex>
                        </div>
                    </A4>
                )
            })}
        </div>
    )
}

export default withRouter(NaviPostageSlipsPage)

type PreviewRequestNaviPostListProps = {
    SplitNaviSamplesList: NaviSample[][]
    type: 'storage' | 'submission'
}

const PreviewRequestNaviPostList = (props: PreviewRequestNaviPostListProps) => {
    return (
        <>
            {props.SplitNaviSamplesList.map((naviSamples, index) => {
                return (
                    <A4 padding={10} landscape={false} key={'checklist-' + index}>
                        <div className={'preview-request-list'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                            <div
                                style={{
                                    border: 'solid 1px',
                                    width: 100,
                                    padding: 10,
                                    position: 'absolute',
                                    top: -35,
                                    right: 0,
                                    fontSize: 18,
                                    textAlign: 'center',
                                }}
                            >
                                {props.type === 'storage' ? '控' : '提出用'}
                            </div>
                            <div style={{ width: '100%', marginBottom: 30, marginTop: 30 }}>
                                <div style={{ fontSize: 25, fontWeight: 'bold', width: '100%', textAlign: 'center' }}>特定記録郵便物差出票</div>
                                <div style={{ textAlign: 'right', marginBottom: 30, marginTop: 30 }}>
                                    〒464-0814 愛知県名古屋市千種区不老町1 NIC711・712号
                                    <br /> Craif株式会社 中部検査センター
                                    <br /> TEL:070-3149-6278
                                </div>
                            </div>

                            <table style={{ width: '100%', border: 'solid 1px black', borderRightWidth: 0, borderBottomWidth: 0, fontSize: 12 }}>
                                <thead>
                                    <tr style={{ borderBottom: 'solid 1px black' }}>
                                        <Th style={{ fontSize: 12, width: 20 }}>#</Th>
                                        <Th style={{ fontSize: 12, width: 100 }}>Craif管理ID</Th>
                                        <Th style={{ fontSize: 12 }}>お届け先のお名前</Th>
                                        <Th style={{ fontSize: 12, width: 140 }}>お問い合わせ番号</Th>
                                        <Th style={{ fontSize: 12, width: 110 }}>申出損害要償額</Th>
                                        <Th style={{ fontSize: 12, width: 80 }}>料金等</Th>
                                        <Th style={{ fontSize: 12, width: 80 }}>摘要</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {new Array(15).fill(0).map((_, sampleIndex) => {
                                        const sample: NaviSample | undefined = naviSamples[sampleIndex]
                                        return (
                                            <tr key={sample?.id} style={{ borderBottom: 'solid 1px black' }}>
                                                <Td style={{ textAlign: 'center' }}>
                                                    <div style={{ minHeight: 28, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div>{sampleIndex + 1}</div>
                                                    </div>
                                                </Td>
                                                <Td>{sample?.code}</Td>
                                                <Td style={{ fontSize: 10, padding: '0 5px' }}>
                                                    {sample
                                                        ? `${sample?.patient?.familyName || ''} ${sample?.patient?.givenName || ''}(${
                                                              sample?.patient?.familyNameKana || ''
                                                          } ${sample?.patient?.givenNameKana || ''})`
                                                        : ''}
                                                </Td>

                                                <Td></Td>
                                                <Td></Td>
                                                <Td style={{ textAlign: 'center' }}>{sample && 'なし'}</Td>
                                                <Td style={{ textAlign: 'center' }}>{sample && 'なし'}</Td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Flex justifyContent="flex-end" style={{ marginTop: 30 }}>
                                <div>
                                    <table style={{ fontSize: 14, border: 'solid 1px black' }}>
                                        <thead style={{ backgroundColor: '#e1e1e1', borderBottom: 'solid 1px black', textAlign: 'center' }}>
                                            <tr>
                                                <th style={{ width: 100, borderRight: 'solid 1px black' }}>封入者</th>
                                                <th style={{ width: 100, borderRight: 'solid 1px black' }}>二次確認者</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderRight: 'solid 1px black' }}>
                                                    <div style={{ height: 60 }}></div>
                                                </td>
                                                <td style={{ borderRight: 'solid 1px black' }}>
                                                    <div style={{ height: 60 }}></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Flex>
                            <Flex justifyContent="space-between" style={{ position: 'absolute', bottom: 20, width: '100%', fontSize: 14 }}>
                                <div>日付：{moment().format('YYYY/MM/DD')}</div>
                                <div>
                                    ページ番号：
                                    {index + 1}/{props.SplitNaviSamplesList.length}
                                </div>
                            </Flex>
                        </div>
                    </A4>
                )
            })}
        </>
    )
}
